/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Radio, RadioChangeEvent } from 'antd';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './QuestionsFilter.styles';
import { useIntl } from 'react-intl';
import IconButton from '~components/_common/IconButton/IconButton';

export enum QuestionsFilterOptions {
  ALL = 'all',
  MY = 'my',
  LETTERS = 'letters',
}

type QuestionsFilterProps = {
  currentFilterOption: QuestionsFilterOptions;
  onCurrentFilterOptionChange: (value: QuestionsFilterOptions) => void;
};

const QuestionsFilter: React.FC<QuestionsFilterProps> = ({
  currentFilterOption,
  onCurrentFilterOptionChange,
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  const questionsFilterOptions = [
    { label: intl.formatMessage({ id: 'qa-option-answer' }), value: 'all' },
    { label: intl.formatMessage({ id: 'qa-option-myquestions' }), value: 'my' },
    {
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <IconButton icon={['far', 'envelope']} backgroundOff />
          {intl.formatMessage({ id: 'qa-option-letters' })}
        </span>
      ),
      value: 'letters',
    },
  ];

  const onQuestionsFilterChange = ({ target: { value } }: RadioChangeEvent) => {
    onCurrentFilterOptionChange(value);
  };

  return (
    <Radio.Group
      options={questionsFilterOptions}
      onChange={onQuestionsFilterChange}
      value={currentFilterOption}
      optionType="button"
      buttonStyle="solid"
    />
  );
};

export default QuestionsFilter;
